import React, { Component, Fragment } from 'react';
import CDBBlogViewer from "../cdb-blog-viewer/CDBBlogViewer";
import SchoolMenu from '../SchoolMenu';

interface HomePageProps {
}

export default class HomePage extends Component<HomePageProps ,any> {
    static displayName = HomePage.name;

    constructor(props: HomePageProps) {
        super(props);

        this.state = {

        }
    }

    async componentDidMount() {
    }
    
    async componentDidUpdate(prevProps: Readonly<HomePageProps>, prevState: Readonly<any>, snapshot?: any) {
        
    }
    
    render () {        
        return (
            <Fragment>
                <SchoolMenu prefix="Home" />
                <div className={"cdb-admin-content cdb-admin-content--column"}>
                    <CDBBlogViewer />
                </div>
            </Fragment>
        );
    }
}
